Namespace 'Monitoring.Views.SocialContents.NewSession'

class Monitoring.Views.SocialContents.NewSession.PublicationsView extends Backbone.View

  template: JST['backbone/templates/monitoring/sessions/new_session/publications']

  initialize: (sortedAvailableChannelsByProvider) ->
    @sortedAvailableChannelsByProvider = sortedAvailableChannelsByProvider
    @vueChannelsByProviderSelector = new VueInBackbone.VueComponent(
      'channels-by-provider-selector',
      {
        channelsByProvider: @sortedAvailableChannelsByProvider,
        texts: {
          chooseProvider: I18n.t('monitoring.publications_session.new_session.choose_provider'),
          chooseChannel: I18n.t('monitoring.publications_session.new_session.search_or_select_channels'),
          selectAll: I18n.t('monitoring.publications_session.new_session.select_all_channels'),
          allSocialEntitiesLabel: I18n.t('monitoring.publications_session.new_session.all_social_entities')
        }
      }
    )

  render: ->
    @$el.html(@template)
    @$el.find('.new-session-publications').html(@vueChannelsByProviderSelector.el)
    @vueChannelsByProviderSelector.render()
    @vueChannelsByProviderSelector.on('select', @updateSelectedChannels)

    @

  updateSelectedChannels: (selection) =>
    @trigger('updateSelectedChannels', selection)

  remove: ->
    @vueChannelsByProviderSelector.remove()
    super()
